import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { BACKEND_SERVER_URL } from '../../../../http/http-config';


import DateInput from '../../Common-Components/DateInput';
import DropdownInput from '../../Common-Components/DropdownInput';
import FileInput from '../../Common-Components/FileInput';
import Input from '../../Common-Components/Input';
import TinyEditor from '../../Common-Components/TinyEditor';
import '../../Course/Course.css';
import { generateUniqueID } from '../../Course/CourseHelper';
import { fetchSubTestData, formateSubTestData } from '.././TestHelper';

let initialFormData = {
    sNo: 0,
    title: '',
    accessCode: 1,
    description: '',
    topic: '',
    questionCount: 100,
    attempts: 1,
    totalMarks: 0,
    positiveMarks: 0,
    negativeMarks: 0,
    duration: 60,
    publishDate: new Date(),
    endDate: new Date(),
    availability: '',
    type: 'MCQ',
    demo: 'NO',
    holdResult: 'NO',
    tags: '',
    notesPDF: '',
    questionPDF: '',
    answerBookPDF: '',
    modelAnswerPDF: '',
    videoURL: '',
    packageId: '',
    courseId: '',
    initialRank: 0,
    batchId: 0,
    show: "YES"
}

const SubTestModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [updatingTestId, setUpdatingTestId] = useState(0);
    const [formData, setFormData] = useState(initialFormData);
    // console.log(formData)
    const selectedBatchId = props?.selectedBatch?.Sn || 0;

    useImperativeHandle(ref, () => ({
        openModal(courseId, packageId) {
            if (packageId) {
                setUpdatingTestId(packageId)
                fetchSubTestData(packageId, selectedBatchId).then((test) => {
                    console.log(test)
                    formateSubTestData(test).then(formatedData => {
                        if (formatedData.title) {
                            setFormData({ ...formatedData, batchId: selectedBatchId, courseId: courseId });
                        }
                    })
                })
            } else {
                console.log('else block');
                setFormData(initialFormData)
                let uniqueId = generateUniqueID();
                handleChange('packageId', uniqueId)//property name and value
                handleChange('courseId', courseId);
                handleChange('batchId', selectedBatchId);
                // setModalBox(true);
            }
            setModalBox(true);
        }
    }));

    const handleChange = (name, value) => {
        console.log(`${name} : ${value}`);
        setFormData((previousData) => ({
            ...previousData,
            [name]: value
        }));
    };

    //  console.log(formData)
    const handleSubmitTest = () => {
        // let errorMessgae = validateSubTestData(formData)
        //  console.log(errorMessgae)
        //  if (errorMessgae) {
        //      toast.error(errorMessgae)
        //      return;
        //  }

        axios.post(BACKEND_SERVER_URL + (updatingTestId ? `/editSubTest/${updatingTestId}` : '/createSubTest'), formData).then((response) => {
            if (response.data.statusCode == 200) {
                console.log("updated")
                setFormData(initialFormData)
                toast.success(response.data.message)
                props.setSubTestLoading(!props.loadSubTests)
                setModalBox(false);
            }
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setUpdatingTestId(0);
            setFormData(initialFormData); // Reset form data when modal is closed
        }
    }, [modalBox]);

    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{updatingTestId ? 'Update Test' : 'Create Test'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input inputType="text" handleChangeCallBack={handleChange} labelName="Title" inputValue={formData?.title} inputName='title' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Sequence No." inputType="number" inputValue={formData?.sNo} inputName='sNo' divSizes={[4, 8]} />
                                </div>
                                {/*   <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Exam Type<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.examType, label: formData.examType }}
                                                onChange={(selectedOption) => setFormData({ ...formData, examTypeId: selectedOption.value.Sn, examType: selectedOption.value.exambody })}
                                                options={examTypesArray?.map((item) => ({ value: item, label: item.exambody }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                            </div>
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Access Code" inputType="number" inputValue={formData?.accessCode} inputName='accessCode' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex ">
                                    <Input handleChangeCallBack={handleChange} labelName="Package ID" inputType="text" inputValue={formData?.packageId} inputName='packageId' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Question Count" inputType="number" inputValue={formData?.questionCount} inputName='questionCount' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Attempt" inputType="number" inputValue={formData?.attempts} inputName='attempts' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Duration (in minutes)" inputType="number" inputValue={formData?.duration} inputName='duration' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Tags" inputType="text" inputValue={formData?.tags} inputName='tags' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Total Marks" inputType="number" inputValue={formData?.totalMarks} inputName='totalMarks' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Marks Per Ques." inputType="number" inputValue={formData?.positiveMarks} inputName='positiveMarks' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Negative Marks" inputType="number" inputValue={formData?.negativeMarks} inputName='negativeMarks' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Hold Result" selectedValue={formData?.holdResult} inputName='holdResult' dropdownValuesArray={['YES', 'NO']} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Demo" selectedValue={formData?.demo} inputName='demo' dropdownValuesArray={['YES', 'NO']} />
                                </div>
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Availibility" selectedValue={formData?.availability} inputName='availability' dropdownValuesArray={['Open to All', 'Close']} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Type" selectedValue={formData?.type} inputName='type' dropdownValuesArray={['MCQ', 'Subjective']} />
                                </div>
                                <div className="col-5 d-flex ">
                                    <Input handleChangeCallBack={handleChange} labelName="Video URL" inputType="text" inputValue={formData?.videoURL} inputName='videoURL' divSizes={[4, 8]} />

                                </div>
                            </div>

                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Publish Date" selected={formData?.publishDate} handleChangeCallBack={handleChange} inputName='publishDate' />
                                </div>
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="End Date" selected={formData?.endDate} handleChangeCallBack={handleChange} inputName='endDate' />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex ">
                                    <Input handleChangeCallBack={handleChange} labelName="Initial Rank" inputType="number" inputValue={formData?.initialRank} inputName='initialRank' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Show Test" selectedValue={formData?.show} inputName='show' dropdownValuesArray={['YES', 'NO']} />
                                </div>
                            </div>

                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.description} inputName='description' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Topic" inputValue={formData?.topic} inputName='topic' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Notes PDF" inputType="text" uploadedFileURL={formData?.notesPDF} inputName='notesPDF' accept=".pdf" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Question PDF" inputType="text" uploadedFileURL={formData?.questionPDF} inputName='questionPDF' accept=".pdf" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Answer Book PDF" inputType="text" uploadedFileURL={formData?.answerBookPDF} inputName='answerBookPDF' accept=".pdf" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Model Answer PDF" inputType="text" uploadedFileURL={formData?.modelAnswerPDF} inputName='modelAnswerPDF' accept=".pdf" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitTest}>{updatingTestId ? 'Update Test' : 'Create Test'}</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default SubTestModal;